<template>
  <div class="third-selectCountry-con">
    <div class="select-country-list">
      <van-field
          left-icon="search"
          clearable
          clear-trigger="always"
          class="van-search-country" 
          @touchstart="handleForceFocus('SearchInput')"
          ref="SearchInput" 
          v-model.trim="search" 
          :placeholder="$t('CountryGroup.placeholder')" 
      >
      </van-field>
      <van-index-bar :index-list="ursor" highlight-color="#323233" ref="indexBar">
        <!-- 搜索出来的 -->
        <div v-if="issearch">
          <van-cell :class="v.iso2 === selectIso2 ? 'isActive' : ''" @click="findviewByButton(v.iso2,v.countryName,true)"
            v-for="(v, k) in iscearchData"
            :key="k"
            :title="v.countryName" />
        </div>
        <div v-if="!issearch">
          <div v-if="isshowType == false">
            <div v-for="(values, key, index) in data" :key="index">
              <van-index-anchor :index="ursor[index]" default="B"/>
              <div v-for="(v, k) in toLowerCaseData(data,ursor[index])" :key="k">
                <van-cell :class="v.iso2 === selectIso2 ? 'isActive' : ''" @click="findviewByButton(v.iso2, v.countryName)" v-if="v.isshow == true" :title="v.countryName" />
              </div>
            </div>
          </div>
          <div v-if="isshowType == true">
            <div v-for="(values, key) in JpData" :key="key">
              <van-index-anchor :index="ursor[key]" v-if="JpData[key]" />
              <div>
                <div v-for="(v, k) in JpData[key]" :key="k">
                  <van-cell :class="v.iso2 === selectIso2 ? 'isActive' : ''" @click="findviewByButton(v.iso2, v.countryName)" :title="v.countryName" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </van-index-bar>
      <div class="foot-btn-con">
            <van-button class="btn" :disabled="!selectIso2" round block type="info" @click="selectCountry()">{{ $t('registerlogin.confirm') }}</van-button>
      </div>
    </div>
  </div>
</template>

<script>
import { Cell, IndexBar, IndexAnchor, Search, Tag } from "vant";
import CountryGroup from "@/assets/country/country.js";
import cookie from "@/utils/cookie";
export default {
    props: {
        iso2List: {
            type: Array,
            default: () => []
        },
        countryData: {
            type: Array,
            default: () => []
        },
        iso2: {
            type: String,
            default: ""
        }
    },
    components: {
        vanTag: Tag,
        vanCell: Cell,
        vanIndexBar: IndexBar,
        vanIndexAnchor: IndexAnchor,
        vanSearch: Search,
    },
    data() {
        return {
            issearch: false,
            iscearchData: [],
            search: "",
            getApiData: [],
            data: {},
            JpData: [],
            isshowType: false,
            ursor: [],
            country: [],
            iscounrty: [],
            gethisCountry: JSON.parse(localStorage.getItem("countryData")),
            selectIso2: "",
            scrollKey: "",
            value: "",
        }
    },
    watch:{
        iso2: {
            handler(newVal) {
                this.selectIso2 = newVal;
            },
            immediate: true
        },
        search(newName) {
        /**
         *监听 select的值 如果检索到了，那么先清空目前的值（newdata 组合后的值） 再将检索的值放到   this.isFilterData 过滤方法中
            否则当输入的值清空时将原始接口的值重新传入 this.isFilterData
        * **/
        if (newName.trim().length > 0) {
            this.gethisCountryclick = false;
            let datas = [];
            this.getApiData.forEach((element, i) => {
            if (element.countryName.toLowerCase().indexOf(newName.toLowerCase().trim()) != -1 && element.iso2 != "ALL") {
                datas.push(element);
            }
            });
            this.issearch = true;
            this.ursor = [];
            this.iscearchData = datas;
        } else if (newName === "") {
            this.gethisCountryclick = true;
            this.issearch = false;
            this.ursor = [];
            this.handlerCountryData();
        }
        },
        // 离开页面清空搜索框
        $route() {
        this.value = "";
        },
    },
    mounted() {
        this.setup();
    },
    methods: {
        setup() {
            this.handlerCountryData();
        },
        // 输入框获取焦点
        handleForceFocus(ref) {
        this.$refs[ref].focus();
        },
        toLowerCaseData(data,key){
        if(!key) {
            return []
        }
        
        let lKey = key.toLowerCase()
        
        return this.data[lKey] || this.data[key]  || [];
        },
        //针对日文单独排序
        JPCountry(data) {
        let newdata = [];
        let unline = [];
        let CountryGroup_Country_JP_group = {};

        this.ursor = CountryGroup.Country_JP.title;
        if (data) {
            for (let T = 0; T < data.length; T++) {
            let element = data[T];
            for (let i = 0; i < CountryGroup.Country_JP.group.length; i++) {
                //初始化
                // newdata[i] =  [];
                //梳理数组Country_JP的当前group值
                CountryGroup.Country_JP.group[i].forEach((j, k) => {
                if (!CountryGroup_Country_JP_group[i]) CountryGroup_Country_JP_group[i] = {};

                if (j.indexOf(element.countryName.charAt(0)) > -1) {
                    if (!CountryGroup_Country_JP_group[i][k]) CountryGroup_Country_JP_group[i][k] = [];
                    CountryGroup_Country_JP_group[i][k].push(element);
                    delete data[data.indexOf(element)];
                }
                });

                //梳理数组Country_JP的当前title项
                try {
                if (CountryGroup_Country_JP_group[i]) {
                    let Current_I_values = Object.values(CountryGroup_Country_JP_group[i]).flat(Infinity);
                    if (Current_I_values.length) {
                    newdata[i] = Current_I_values;
                    } else {
                    //不处理
                    }
                } else {
                    //不处理
                }
                } catch (e) {
                //不赋值不处理
                }
            }
            }

            try {
            //#处理剩余值
            let Last_diff_data = data.flat(Infinity);
            // 去除全球
            Last_diff_data.forEach((element) => {
                if (element.iso2 == "ALL") {
                Last_diff_data.splice(element, 1);
                }
            });
            newdata[10] = Last_diff_data;
            } catch (e) {}

            // newdata.forEach(element => {
            //   unline.push(...element)
            // });
            //  let diff = data.filter(function (val) { return unline.indexOf(val) === -1 }) // 获取差集
            //  diff.forEach(element => { // 去除全球
            //    if(element.iso2=="ALL"){
            //    diff.splice(element,1)
            //    }
            //  });
            //  newdata.push(diff)

            if (newdata && newdata.length) {
            try {
                this.JpData = JSON.parse(JSON.stringify(newdata));
            } catch (e) {
                console.log(newdata);
            }
            }
        }
        },
        handlerCountryData() {
            if (this.countryData && this.countryData.length) {

                if(this.iso2List.includes('ALL')){
                    this.getApiData = this.countryData;
                } else {
                this.getApiData = this.countryData.filter((item) => {
                    return this.iso2List.includes(item.iso2)
                });
                }

                this.isshowType = false;
                if (cookie.get("langType") === "zh-CN") {
                    this.countryGroup(this.getApiData, CountryGroup.Country_CN);
                } else if (cookie.get("langType") === "zh-TW") {
                    this.countryGroup(this.getApiData, CountryGroup.Country_TW);
                } else if (cookie.get("langType") === "en-US") {
                    this.countryGroup(this.getApiData, CountryGroup.Country_US);
                } else if (cookie.get("langType") === "ja-JP") {
                    this.isshowType = true;
                    this.JPCountry(this.getApiData);
                } else if (cookie.get("langType") === "tr-TR") {
                    this.countryGroup(this.getApiData, CountryGroup.Country_TR);
                } else {
                    this.countryGroup(this.getApiData, CountryGroup.Country_US);
                }

                if(this.scrollKey){
                    this.$nextTick(()=>{
                        this.$refs.indexBar.scrollTo(this.scrollKey);
                    });                    
                }
            }
        },
        countryGroup(val, countryLang) {
            let ordered = {};
            let getursor = [];
            Object.keys(countryLang)
                .sort()
                .forEach((key) => {
                    ordered[key] = countryLang[key];
                });
            val.forEach((item) => {
                this.iscounrty.push(item.iso2);
            });

            for (let key in ordered) {
                this.ursor.push(key.toUpperCase());
                this.country.push(countryLang[key]);
                ordered[key].forEach((element) => {
                    let country = val.find((item) => {
                        if(item.iso2 === element.iso2 && this.selectIso2 === item.iso2){
                            // 
                            this.scrollKey = key.toUpperCase();
                        }
                        return item.iso2 === element.iso2;
                    });
                    if (country?.countryName) {
                        element.countryName = country?.countryName;
                    }
                    
                });
            }

            for (let i = 0; i < this.country.length; i++) {
                let K = 0; // 去除当首字母下没有匹配到数据 那么 吧首字母去掉
                let Q = 0;
                for (let j = 0; j < this.country[i].length; j++) {
                if (this.iscounrty.indexOf(this.country[i][j].iso2) == -1) {
                    K = K + 1;
                    this.country[i][j].isshow = false;
                    if (this.country[i].length === K) {
                    getursor.push(this.ursor[i]);
                    }
                } else if (this.country[i][j].iso2 === "ALL") {
                    // 去除全球
                    Q = Q + 1;
                    this.country[i][j].isshow = false;
                    if (this.country[i].length === Q) {
                    getursor.push(this.ursor[i]);
                    }
                } else {
                    this.country[i][j].isshow = true;
                }
                }
            }
            
            // for (let s = 0; s < getursor.length; s++) {
            //   // let t = 0;
            //   // if (s != 0) {
            //   //   t = t + 1;
            //   // }
            //   try {
            //     if (cookie.get("langType") === "en-US") {
            //       // if(!!this.ShowTitle[lang_key]){
            //       //    let lang_key= this.ursor[getursor[s]-t].toUpperCase()
            //       //   this.ShowTitle[lang_key]={}
            //       //   this.ShowTitle[lang_key].isshow = true
            //       // }
            //       delete ordered[this.ursor[getursor[s]].toUpperCase()];
            //     } else {
            //       delete ordered[this.ursor[getursor[s]].toLowerCase()];
            //     }
            //   } catch (error) {}
            // }

            this.ursor = this.ursor.filter((item) => {
                return !getursor.includes(item);
            });
            
            this.data = ordered;
        },
        //点击国家
        findviewByButton(iso, name, isSearch) {
            this.selectIso2 = iso;
            if(isSearch){
                this.search = '';
            }
        },
        selectCountry(){
            this.$dialog.confirm({
                title:this.$t('flowDetail.tip'),
                message: this.$t('registerlogin.selectCountry_tips'),
                confirmButtonText:this.$t('registerlogin.confirm'),
                cancelButtonText:this.$t('registerlogin.cancel')
            }).then(() => {
                // 神策-点击选择注册国家
                this.$sensors.track("WebChooseRegisterCountry", {
                    country_iso2: this.selectIso2,
                    imei: this.$route.query.imei,
                    enterprisecode: this.$route.query.enterprisecode,
                });
                setTimeout(() => {
                    this.$emit('selectCountry', {iso2: this.selectIso2} );
                }, 100);
            }).catch(() => {
            })
        },
    }
}
</script>

<style lang="less" scoped>
.third-selectCountry-con {
    background-color: #f2f2f2;
    position: absolute;
    z-index: 10;
    left: 0;
    top: 0;
    min-height: 100vh;
    min-height: 100dvh;
    width: 100%;
    // min-width: 100vw;
    // min-width: 100dvw;
    padding: 10px;
    .select-country-list {
        position: relative;
        overflow: hidden;
        background-color: #fff;
        border-radius: 8px;
        min-height: calc(100vh - 20px);
        min-height: calc(100dvh - 20px);
        padding-bottom: 40px;
    }
    .van-search-country {
        border-bottom: 1px solid #e5e5e5c2;
    }
    .foot-btn-con {
        height: 38px;
        position: fixed;
        left: 0;
        right: 0;
        bottom: 13px;
        padding: 0px 20px;
        .btn {
            height: 38px;
            line-height: 38px;
            background-color: #4361ee;
        }
    }
    .isActive {
        background-color: rgba(67, 97, 238, 0.2);
        color: #4361ee;
    }
}
html[dir="rtl"] .third-selectCountry-con {
    ::v-deep .van-index-bar {
        .van-index-bar__sidebar {
        right: unset;
        left: 0;
        .van-index-bar__index {
            padding-left: 8px;
        }
        }
    }
}
</style>